import React from 'react';
import { Route } from 'react-router-dom';
import Login from '../Shared/Login/Login';
import { createBrowserHistory } from 'history';
import { Router, Switch } from 'react-router-dom';
import ConfirmAccount from '../Shared/Account/ConfirmAccount';
import ConfirmLearnerAccount from '../Shared/Account/ConfirmLearnerAccount';
import PrivacyPolicy from '../Pages/GDPR/PrivacyPolicy';
import Certificate from '../Pages/ELearning/Courses/Certificate';
import VerifyCertificate from '../Pages/ELearning/Courses/VerifyCertificate';

const history = createBrowserHistory();

const AnnonymousRoutes = props => {
    return (
        <Router history={history}>
            <Switch>
                <Route exact path="/">
                    <Login />
                </Route>
                <Route exact path="/confirm/:userId/:token" component={ConfirmAccount} />
                <Route exact path="/Confirm/:userId/:token" component={ConfirmAccount} />
                <Route exact path="/register/:userId/:token" component={ConfirmLearnerAccount} />
                <Route exact path="/Register/:userId/:token" component={ConfirmLearnerAccount} />

                <Route exact path="/gdpr/privacy" component={PrivacyPolicy} />
                {/* Public (also used when logged in - see isAnonymousPublicPath in App.js). :id is the learner-course id. */}
                <Route exact path="/certificate/:id" component={Certificate} />
                <Route exact path="/verify/:id" component={VerifyCertificate} />
            </Switch>
        </Router>
    );
};

export default AnnonymousRoutes;